module.exports = __webpack_public_path__ + "static/media/KC.b556a8d9.png";